<template>
  <el-form>
    <div class="row">
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('search')"
          class="material-style"
        >
          <select-response-auto-complete
            :model="value"
            @update:model="$emit('input', $event)"
            :columns="columns"
            api="RFQs/GetAllDynamic"
            :selected="selected"
            searchAllColumns
            :fields="{id: 'id', title: 'rfqid'}"
            filters='po!=null&&po!=""&&po!="-1"&&poIsOpen==true'
            :orderBy="{ fields: 'poDate', order: 'desc' }"
          >
          </select-response-auto-complete>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { filterStartsWith } from '@/utils/shared'

export default {
  name: 'TopPanel',
  props: {
    value: { default: null }
  },
  computed: {
    selected () {
      return [
        'id', 'po', 'poDate', 'customerCompany.name as customerCompanyName', 'rfqid'
      ].join(',')
    },
    columns () {
      return [
        { title: this.L10n('po-date'), value: 'poDate', type: 'date' },
        { title: this.L10n('po'), value: 'po', originField: 'po', type: 'string' },
        { title: this.L10n('customer-name'), value: 'customerCompanyName', originField: 'customerCompany.name', type: 'custom', customFilter: filterStartsWith },
        { title: this.L10n('rfq-id'), value: 'rfqid', originField: 'rfqid', type: 'string' }
      ]
    }
  }
}
</script>
